export default __webpack_public_path__ + "static/lightStaticStill-273a01cde863a5178dc6a285c7a29132.png";